import React from 'react'
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import KITCHEN_PNG from "../../global/assets/png/Kitchen-FirstTimeChecker.png"
import LoginForm from '../../composed/loginflow/LoginForm'
import './ForgotPassword.scss'
import ForgotPasswordForm from '../../composed/loginflow/ForgotPasswordForm'
import Transition from './../../transition';

const ForgotPassword = () => {

    if (isMobile) {
        return (
            <ForgotPasswordForm />
        )
    }
    if (isIpad) {
        return (
            <ForgotPasswordForm />
        )
    }


    return (
        <div className='forgotpassword-desktop-container'>

            <div className='section-1-forgotpassword-desktop'>
                {/* <img style={{ width: '100%', }} src={KITCHEN_PNG}></img> */}
            </div>
            <div className='section-2-forgotpassword-desktop'> <ForgotPasswordForm /> </div>

        </div>
    )
}

export default Transition(ForgotPassword)